import { Search, Cpu, Filter, ShieldCheck, Send } from 'lucide-react'
import { ArrowRight, ArrowDown } from 'lucide-react'
import { TELEGRAM_BOT_URL } from '@/lib/constants'
import { useScrollReveal } from '@/hooks/useScrollReveal'

const STEPS = [
  {
    icon: Search,
    title: 'Análisis de variables',
    body: 'El sistema procesa cientos de señales por partido: forma, cuotas, contexto, historial, clima y más.',
    color: 'from-brand/20 to-brand/5',
  },
  {
    icon: Cpu,
    title: 'Motores de IA generan probabilidades',
    body: 'Simulación Monte Carlo, modelos estadísticos y análisis de mercado calculan la probabilidad real de cada resultado.',
    color: 'from-brand/15 to-brand/5',
  },
  {
    icon: Filter,
    title: 'El Decision Engine valida',
    body: 'Un motor central evalúa si el pick cumple umbrales mínimos de confianza, valor esperado y riesgo.',
    color: 'from-brand/15 to-brand/5',
  },
  {
    icon: ShieldCheck,
    title: 'Solo si supera todos los filtros',
    body: 'Si el pick no pasa todos los controles de calidad, simplemente no se publica. Cero picks por cumplir cuota.',
    color: 'from-brand/15 to-brand/5',
  },
  {
    icon: Send,
    title: 'Recibes el pick en Telegram',
    body: 'El Top Pick validado llega directo a tu Mini App de Telegram cada mañana, listo para usar.',
    color: 'from-brand/20 to-brand/5',
  },
]

export function HowItWorks() {
  const ref = useScrollReveal<HTMLElement>()

  return (
    <section ref={ref} className="bg-panel/40 border-y border-border">
      <div className="max-w-5xl mx-auto px-5 py-20">
        <div className="text-center mb-16 reveal">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand mb-2">
            Cómo funciona
          </p>
          <h2 className="font-display text-3xl sm:text-4xl font-bold">
            De la señal a tu Telegram
          </h2>
          <p className="mt-3 text-text-dim max-w-lg mx-auto text-sm leading-relaxed">
            5 etapas de filtrado real. Un pick solo se publica si supera cada una de ellas.
          </p>
        </div>

        {/* Timeline vertical on mobile, horizontal connector on desktop */}
        <div className="relative">
          {/* Desktop connector line */}
          <div className="hidden lg:block absolute top-10 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-brand/30 to-transparent" />

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-4">
            {STEPS.map((step, i) => (
              <div key={step.title} className="flex flex-col items-center lg:items-center text-center">
                {/* Step number + icon */}
                <div
                  className={`reveal relative z-10 h-20 w-20 rounded-2xl bg-gradient-to-br ${step.color} border border-brand/20 flex flex-col items-center justify-center gap-1 mb-4`}
                  style={{ transitionDelay: `${i * 100}ms` }}
                >
                  <step.icon className="h-6 w-6 text-brand" />
                  <span className="text-[10px] font-bold text-brand/60">0{i + 1}</span>
                </div>

                {/* Arrow between steps (mobile only) */}
                {i < STEPS.length - 1 && (
                  <div className="lg:hidden flex justify-center my-1">
                    <ArrowDown className="h-4 w-4 text-brand/30" />
                  </div>
                )}

                <div
                  className="reveal space-y-1.5"
                  style={{ transitionDelay: `${i * 100 + 60}ms` }}
                >
                  <h3 className="font-display text-base font-bold leading-tight">{step.title}</h3>
                  <p className="text-xs text-text-dim leading-relaxed">{step.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="cta-strip reveal" style={{ transitionDelay: '300ms' }}>
          <a href={TELEGRAM_BOT_URL} target="_blank" rel="noopener noreferrer" className="btn-brand">
            Empezar ahora
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  )
}
